import AxiosClient from "../../../services/axios.services";

class CompetenciesFunServices {
  getCompetencyFun = (params) =>
    AxiosClient.get(
      "/api/app/carrera_competencias_funcion/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );

  getCompetency = (params) =>
    AxiosClient.get(
      "/api/app/carrera_competencia/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );

  getTasks = (params, iType) =>
    AxiosClient.get(
      iType === 1
        ? `/api/app/Funcional_Funciones/`
        : `/api/app/Formal_Funciones/`,
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );

  editCompetencyFun = (id, data) =>
    AxiosClient.put(
      `/api/app/carrera_competencias_funcion/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  saveCompetencyFun = (data) =>
    AxiosClient.post(
      "/api/app/carrera_competencias_funcion/",
      data,
      {
        headers: { "Content-Type": "application/json" },

      },

    );
  deleteCompetencyFun = (id) =>
    AxiosClient.delete(
      `/api/app/carrera_competencias_funcion/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

}

export default new CompetenciesFunServices();
